"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Emit;
    }
});
const _emittery = /*#__PURE__*/ _interop_require_default(require("emittery"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let emitSingleton = null;
let Emit = class Emit {
    constructor(){
        if (emitSingleton) return emitSingleton;
        this.evt = new _emittery.default();
        emitSingleton = this;
    }
};
